export default "__VITE_ASSET__dP9RAJ86__"